import { useEffect, useRef, useState } from "react"
import DelayedCloseButton from "../../../components/DelayedCloseButton/DelayedCloseButton"
import FullScreenPage from "../../../components/FullScreenPage/FullScreenPage"
import PrimaryButton from "../../../components/PrimaryButton/PrimaryButton"
import TermsButtons from "../../../components/TermsButtons/TermsButtons"
import { usePurchase } from "../../../context/purchaseContext"
import useStrings from "../../../localization/useStrings"
import native from "../../../native/native"
import images from "../../../utils/images"
import { formatCurrency, formatProductPrice } from "../../../utils/utils"
import styles from "./PurchasePaywallStep.module.scss"
import { useMultiStep } from "../../../context/multiStepContext"

const PurchasePaywallStep = () => {
  const strings = useStrings().multistep
  const product = usePurchase().state.selectedPlan.yearlyProduct

  const setShowBottomSheet = useMultiStep().actions.setShowBottomSheet

  return (
    <FullScreenPage containerClassName={styles.container}>
      <div className={styles.centeredContent}>
        <DelayedCloseButton
          className={styles.closeButton}
          onClick={() => {
            native.postNativeEvent("close")
          }}
        />
        <label className={styles.title}>{strings.payTitle}</label>
        <label className={styles.billingMonthly}>
          {strings.afterPrice(
            formatCurrency(product.price / 12, product.priceLocale)
          )}
        </label>
        <label className={styles.billingYearly}>
          {strings.afterBilling(formatProductPrice(product))}
        </label>
        <div className={images.multistep.happyUsers.class} />
        <div className={styles.reviewTopSpacer} />
        <ReviewContainer />
      </div>
      <div className={styles.footer}>
        <label className={styles.footerSubtitle}>{strings.noPaymentNow}</label>
        <PrimaryButton
          className={styles.cta}
          onClick={() => {
            setShowBottomSheet(true)
          }}
        >
          {strings.startFreeWeek}
        </PrimaryButton>
        <TermsButtons
          containerClass={styles.termsContainer}
          buttonClass={styles.termsButton}
        />
      </div>
    </FullScreenPage>
  )
}

const ReviewContainer = () => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [currentIndex, setCurrentIndex] = useState(0)

  const reviews = [
    {
      content:
        "This app gave me total peace of mind by letting me lock private videos.",
      user: "— Jason, 42 🇺🇸",
    },
    {
      content:
        "All in one place. No more worrying when someone borrows my phone!!",
      user: "— Mark, 32 🇺🇸",
    },
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % reviews.length

        // Scroll to the next review
        const container = containerRef.current
        if (container) {
          const reviewWidth = 290 // width of each review box
          const gap = 12 // gap between reviews
          const scrollPosition = nextIndex * (reviewWidth * 2 + gap)

          container.scrollTo({
            left: scrollPosition,
            behavior: "smooth",
          })
        }

        return nextIndex
      })
    }, 5000) // 5 seconds

    return () => clearInterval(interval)
  }, [reviews.length])

  return (
    <div ref={containerRef} className={styles.reviewContainer}>
      {reviews.map((review, index) => (
        <ReviewBox key={index} content={review.content} user={review.user} />
      ))}
    </div>
  )
}

const ReviewBox = ({ content, user }) => {
  return (
    <div className={styles.reviewBox}>
      <div
        className={`${images.multistep.stars.class} ${styles.reviewStars}`}
      />
      <label className={styles.reviewContent}>{content}</label>
      <label className={styles.reviewUser}>{user}</label>
    </div>
  )
}

export default PurchasePaywallStep
